export const POSTNL_CARRIER_RATES_BETA_FLAG = 'edit_contract_rates'
export const DHL_DE_CARRIER_RATES_BETA_FLAG = 'edit_dhl_de_contract_rates'
